import styled from 'styled-components';
export var Parent = styled.span.withConfig({
  displayName: "style__Parent",
  componentId: "sc-1e286mp-0"
})(["position:relative;display:flex;align-items:center;justify-content:center;", ";", ";", ";", " ", " ", " ", " svg{font-size:1.7142857142857142rem;height:1em;width:1em;", ";", ";overflow:visible;display:inline-block;transition:all 0.3s;", "}"], function (props) {
  return props.parentWidth && "width: ".concat(props.parentWidth);
}, function (props) {
  return props.parentHeight && "height: ".concat(props.parentHeight);
}, function (props) {
  return props.onClick && "cursor: pointer";
}, function (props) {
  return props.circle && "\n      border-radius: 50%;\n    ";
}, function (props) {
  return props.bgColor && "\n      background-color: ".concat(props.bgColor, ";\n    ");
}, function (props) {
  return props.flipH && "\n        transform: scaleX(-1);\n        filter: FlipH;\n    ";
}, function (_ref) {
  var inline = _ref.inline;
  return inline && "\n        margin: auto;      \n      ";
}, function (props) {
  return props.parentWidth && "width: ".concat(props.parentWidth);
}, function (props) {
  return props.parentHeight && "height: ".concat(props.parentHeight);
}, function (props) {
  var color = 'inherit';
  if (props.svgColor === 'primary') {
    color = props.theme && props.theme.primary.main;
  } else if (props.svgColor === 'secondary') {
    color = props.theme && props.theme.secondary.main;
  } else if (props.svgColor) {
    color = props.svgColor;
  }
  return color && "\n        rect,\n        circle,\n        ellipse,\n        line,\n        polygon,\n        polyline,\n        path {\n          fill: ".concat(color, ";\n        }\n      ");
});